exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.home-welfare-section {\n  width: 100%;\n  overflow: hidden;\n  padding-left: 0.533333rem;\n}\n.home-welfare-section .home-title {\n  font-size: 0.506667rem;\n  font-family: PingFangSC-Medium, PingFang SC;\n  font-weight: 500;\n  color: #333333;\n  margin-top: 0.8rem;\n}\n.home-welfare-section .van-swipe {\n  overflow: initial;\n}\n.home-welfare-section .welfare-swiper {\n  margin-top: 0.266667rem;\n  height: 5.866667rem;\n  width: 9.466667rem;\n  box-sizing: content-box;\n}\n.home-welfare-section .item img {\n  width: 8rem;\n  height: 5.866667rem;\n  object-fit: contain;\n}", ""]);

// exports
